import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "../../../shadcn/components/ui/input-otp";
import React, { SetStateAction, useState } from "react";

interface props {
  otpEntered?: string;
  setOtpEntered: React.Dispatch<SetStateAction<string>>;
  bgColor?: string;
  onSubmit?: () => void;
}

export function OTPInputComponent({
  otpEntered,
  setOtpEntered,
  bgColor = "bg-[#F6F6F6]",
  onSubmit,
}: props) {
  return (
    <InputOTP
      value={otpEntered}
      onChange={(value: any) => {
        setOtpEntered(value);
      }}
      maxLength={6}
      onKeyDown={(e: any) => {
        if (e.key === "Enter" && onSubmit) {
          e.preventDefault();
          onSubmit();
        }
      }}
    >
      <InputOTPGroup className=" w-full gap-x-3">
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={0}
        />
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={1}
        />
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={2}
        />
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={3}
        />
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={4}
        />
        <InputOTPSlot
          className={`${bgColor} border-none rounded-none h-[58px] w-12`}
          index={5}
        />
      </InputOTPGroup>
    </InputOTP>
  );
}
